import { CheckIcon } from '@heroicons/react/16/solid'
import type React from 'react'
import { cn } from '@/app/_lib/utils'

type IconOnTheLeftWithContentLayoutProps = {
  mainContent: React.ReactNode
  children?: React.ReactNode
  className?: string
}

export function IconOnTheLeftWithContentLayout({
  mainContent,
  children,
  className
}: IconOnTheLeftWithContentLayoutProps) {
  return (
    <div className='flex flex-col gap-2'>
      <div className='flex flex-row items-start gap-x-1'>
        <CheckIcon className={cn('mt-1 h-4.5 w-4.5 text-algoprimary', className)} />
        <div className='flex-1'>{mainContent}</div>
      </div>
      <div>{children}</div>
    </div>
  )
}
